import React, { useContext, useState } from "react";


import { LOCALIZATION_KEY } from "../constants";
import dictionary, { DEFAULT_LOCALE, LANGUAGES, LOCALES } from "../Dictionary";


const LocalizationContext = React.createContext();

export function useLocalizationContext() {
    return useContext(LocalizationContext);
}


export default function Context({ children }) {
    const [locale, setLocale] = useState(() => {
        let key = localStorage.getItem(LOCALIZATION_KEY)

        if (!LOCALES.includes(key)) {
            return DEFAULT_LOCALE
        }

        return key;
    })


    const onChange = (value) => {
        let code = value;
        if (!LOCALES.includes(code)) {
            code = DEFAULT_LOCALE
        }

        localStorage.setItem(LOCALIZATION_KEY, code)
        setLocale(code)
    }

    return <LocalizationContext.Provider
        value={{
            current: locale,
            data: LANGUAGES?.find(item => item.value === locale),
            dictionary: dictionary(locale) || {},
            onChange: onChange
        }}
    >
        <div key={locale}>
            {children}
        </div>
    </ LocalizationContext.Provider>
}